import BaseSyncError from "scripts/exceptions/baseSyncError";

class GeneralSyncError extends BaseSyncError {}

export default GeneralSyncError;
